export const DEFAULT_SIZE = '300'; // aka 16px, xxs
export const DEFAULT_COLOR = 'icon-core-default';
const ICON_SIZES = {
  small: 16,
  medium: 32,
  large: 48,
  xxs: 16,
  xs: 24,
  sm: 48,
  md: 64,
  lg: 72,
  xl: 96,
  xxl: 128
};

// From https://git.hubteam.com/HubSpot/foundations-assets/blob/master/foundations-assets/static-1.2466/js/icons/useIconSize.ts
// which is not a public module so had to copy it here
const iconSizeMap = {
  '100': '12px',
  '200': '14px',
  '300': '16px',
  '400': '18px',
  '500': '20px',
  '600': '24px',
  '700': '28px',
  '800': '32px',
  '850': '36px',
  '900': '48px',
  '1000': '64px',
  '1100': '72px',
  '1200': '96px',
  '1300': '128px'
};
const FOUNDATIONS_ICON_SIZE_BY_NUMBER_SIZE = Object.keys(iconSizeMap).reduce((acc, size) => {
  const numericSize = parseInt(iconSizeMap[size], 10);
  acc[numericSize] = size;
  return acc;
}, {});
export const getNumericIconSize = size => {
  if (typeof size === 'number') {
    return size;
  }
  if (ICON_SIZES[size]) {
    return ICON_SIZES[size];
  }
  if (iconSizeMap[size]) {
    return parseInt(iconSizeMap[size], 10);
  }
  return parseInt(iconSizeMap[DEFAULT_SIZE], 10);
};
export const getFoundationsIconSize = size => {
  if (typeof size === 'number') {
    if (FOUNDATIONS_ICON_SIZE_BY_NUMBER_SIZE[size]) return FOUNDATIONS_ICON_SIZE_BY_NUMBER_SIZE[size];
    let closestSize = '100';
    for (const numericSize of Object.keys(FOUNDATIONS_ICON_SIZE_BY_NUMBER_SIZE)) {
      if (size < parseInt(numericSize, 10)) {
        return closestSize;
      }
      closestSize = FOUNDATIONS_ICON_SIZE_BY_NUMBER_SIZE[numericSize];
    }
    return closestSize;
  }
  if (ICON_SIZES[size]) {
    return FOUNDATIONS_ICON_SIZE_BY_NUMBER_SIZE[ICON_SIZES[size]];
  }
  if (iconSizeMap[size]) {
    return size;
  }
  return DEFAULT_SIZE;
};
export const getIconColor = (color, theme) => {
  if (theme.color[color]) {
    return color;
  }
  const colorKey = color && Object.keys(theme.color).find(key => theme.color[key].toLowerCase() === color.toLowerCase());
  return colorKey || DEFAULT_COLOR;
};